var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "panel", attrs: { id: "panel-4" } }, [
        _c("div", { staticClass: "panel-hdr" }, [
          _c("h2", [
            _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.__t("LIST")) + " "),
            _c("span", { staticClass: "fw-300" }, [
              _c("i", [_vm._v(_vm._s(_vm.__t("ORDERS")))]),
            ]),
          ]),
          _vm._v(" "),
          _vm._m(0),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "panel-container show" }, [
          _c(
            "div",
            { staticClass: "panel-content" },
            [
              _c(
                "div",
                { staticClass: "filter_block mb-3" },
                [_c("filter_head")],
                1
              ),
              _vm._v(" "),
              _vm.is_load
                ? _c("b-skeleton-table", {
                    attrs: {
                      rows: this.cur_records,
                      columns: 2,
                      "hide-header": true,
                      "table-props": { bordered: false, striped: true },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.is_load
                ? _c(
                    "div",
                    { staticClass: "inbox_vue_list" },
                    [
                      _vm.rows.length > 0
                        ? _c(
                            "div",
                            { staticClass: "inb_pagi pt-4" },
                            [
                              _c("pagination_list", {
                                key: "up",
                                attrs: {
                                  total: _vm.pagination.total,
                                  limit: _vm.pagination.limit,
                                  current: _vm.pagination.pagesCurrent,
                                },
                                on: { "page-change": _vm.handlePageChange },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.rows.length > 0
                        ? _c("b-table", {
                            staticClass: "table-responsive-xl resolution_table",
                            attrs: {
                              "tbody-tr-class": _vm.rowClass,
                              striped: "",
                              items: _vm.rows,
                              fields: _vm.fields,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "head(id)",
                                  fn: function (data) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "status_info",
                                          staticStyle: { "max-width": "50px" },
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(_vm.__t("O_STATUS")) +
                                              "\n\t\t\t\t\t\t\t\t"
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "head(order_export_provider)",
                                  fn: function (data) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "status_info",
                                          staticStyle: { "max-width": "50px" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(_vm.__t("O_EXP_IC")) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "head(glovo_restaurant)",
                                  fn: function (data) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "status_info",
                                          staticStyle: { "max-width": "50px" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(_vm.__t("O_RESTAURANT")) +
                                              "\n\t\t\t\t\t\t\t\t"
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "head(uniq)",
                                  fn: function (data) {
                                    return [
                                      _c("grid_list", {
                                        attrs: {
                                          list_ordering: "uniq",
                                          field_name: _vm.__t("UNIQ"),
                                          current_ordering: _vm.list.ordering,
                                          current_direction: _vm.list.direction,
                                        },
                                        on: {
                                          "update-order": _vm.handleOrdering,
                                        },
                                      }),
                                    ]
                                  },
                                },
                                {
                                  key: "head(cost)",
                                  fn: function (data) {
                                    return [
                                      _c("grid_list", {
                                        attrs: {
                                          list_ordering: "cost",
                                          field_name: _vm.__t("COST"),
                                          current_ordering: _vm.list.ordering,
                                          current_direction: _vm.list.direction,
                                        },
                                        on: {
                                          "update-order": _vm.handleOrdering,
                                        },
                                      }),
                                    ]
                                  },
                                },
                                {
                                  key: "head(added)",
                                  fn: function (data) {
                                    return [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t" +
                                          _vm._s(_vm.__t("DATE")) +
                                          "\n\t\t\t\t\t\t\t"
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "cell(can_pdf)",
                                  fn: function (data) {
                                    return [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "pdf_link cursor-pointer",
                                          attrs: {
                                            target: "_blank",
                                            href:
                                              "/internal/v1/catalog/orders/" +
                                              data.item.id +
                                              "/pdf",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "icon-stack fs-xxl mt-3",
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "base base-19 icon-stack-3x opacity-100 color-primary-900",
                                              }),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass:
                                                  "fal fa-file-pdf icon-stack-1x opacity-100 color-white",
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "cell(order_export_provider)",
                                  fn: function (data) {
                                    return [
                                      _vm.obj_to_null(data.item.aggregator)
                                        ? _c(
                                            "div",
                                            { staticClass: "provider_img" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "icon" },
                                                [
                                                  _vm.obj_to_null(
                                                    data.item.aggregator
                                                      .icon_url
                                                  )
                                                    ? _c("img", {
                                                        staticClass:
                                                          "order_prov_image",
                                                        attrs: {
                                                          src: data.item
                                                            .aggregator
                                                            .icon_url,
                                                          alt: "",
                                                        },
                                                      })
                                                    : _c("i", {
                                                        staticClass:
                                                          "fal fa fa-file-o fa-file",
                                                      }),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                                {
                                  key: "cell(uniq)",
                                  fn: function (data) {
                                    return [
                                      _c("div", {}, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex flex-start w-100 fs-xl mb-2",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "icon-stack fs-xxl mr-2 cursor-pointer cursor-pointer",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.open_order(
                                                      data.item
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "base base-15 icon-stack-3x opacity-100 color-primary-900",
                                                }),
                                                _vm._v(" "),
                                                _c("i", {
                                                  staticClass:
                                                    "fal fa-indent icon-stack-1x opacity-100 color-white",
                                                }),
                                              ]
                                            ),
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(data.item.order_code) +
                                                "\n                                    "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex flex-start w-100 prov_block",
                                          },
                                          [
                                            data.item.is_delivery_provider
                                              ? _c("div", [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "small badge border border-success",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(
                                                            data.item.pos.type
                                                          ) +
                                                          "\n\n                                            "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "pl-2 pr-2",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                    -->\n                                                "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "small badge border border-warning",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(
                                                            data.item
                                                              .provider_in_txt
                                                          ) +
                                                          "\n                                            "
                                                      ),
                                                    ]
                                                  ),
                                                ])
                                              : _c("div", [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "small badge border border-success",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(
                                                            data.item
                                                              .provider_in_txt
                                                          ) +
                                                          "\n                                            "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "pl-2 pr-2",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                    -->\n                                                "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "small badge border border-warning",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(
                                                            data.item.pos.type
                                                          ) +
                                                          "\n                                            "
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                                {
                                  key: "cell(id)",
                                  fn: function (data) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "small badge p-2",
                                          class: _vm.get_order_class(data.item),
                                          staticStyle: { "max-width": "200px" },
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm.build_order_status(
                                                  data.item
                                                )
                                              ) +
                                              "\n\t\t\t\t\t\t\t\t"
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "cell(glovo_restaurant)",
                                  fn: function (data) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex flex-start w-100 mb-2",
                                        },
                                        [
                                          _vm.obj_to_null(data.item.location)
                                            ? _c("div", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "small badge border border-success",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          data.item.location
                                                            .title
                                                        ) +
                                                        " -\n                                            " +
                                                        _vm._s(
                                                          data.item.location
                                                            .uniq_id
                                                        ) +
                                                        "\n                                        "
                                                    ),
                                                  ]
                                                ),
                                              ])
                                            : _vm._e(),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm.obj_to_null(data.item.pos_rest)
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "small badge border border-warning",
                                                staticStyle: {
                                                  "max-width": "200px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      data.item.pos_rest.title
                                                    ) +
                                                    "\n\t\t\t\t\t\t\t\t\t"
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              {
                                                attrs: {
                                                  сlass:
                                                    "small badge border border-danger",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\tНе знайдено\n\t\t\t\t\t\t\t\t\t"
                                                ),
                                              ]
                                            ),
                                      ]),
                                    ]
                                  },
                                },
                                {
                                  key: "cell(added)",
                                  fn: function (data) {
                                    return [
                                      _c("div", [
                                        _c(
                                          "div",
                                          { staticClass: "badge badge-info" },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\tIN -> " +
                                                _vm._s(
                                                  data.item.times_data.market
                                                    .added_human
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t\t"
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "badge badge-success",
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\tDELIVERY ->  " +
                                                _vm._s(
                                                  data.item.times_data.market
                                                    .estimate_human
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t\t"
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                                {
                                  key: "cell(cost)",
                                  fn: function (data) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "prod_price bold color-primary-900 mt-4",
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                new Intl.NumberFormat(
                                                  "ru-RU"
                                                ).format(
                                                  parseFloat(data.item.price)
                                                )
                                              ) +
                                              "\n\t\t\t\t\t\t\t\t\t"
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "woocommerce-Price-currencySymbol fs-sm",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm._f("getCurrency")(
                                                      data.item.price
                                                    )
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2977398161
                            ),
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.rows.length > 0
                        ? _c(
                            "div",
                            { staticClass: "inb_pagi pt-4" },
                            [
                              _c("pagination_list", {
                                key: "down",
                                attrs: {
                                  total: _vm.pagination.total,
                                  limit: _vm.pagination.limit,
                                  current: _vm.pagination.pagesCurrent,
                                },
                                on: { "page-change": _vm.handlePageChange },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("order_modal"),
      _vm._v(" "),
      _c("order_modal", {
        attrs: { event_name: "order_modal_secondary", show_client_tab: false },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel-toolbar" }, [
      _c("button", {
        staticClass: "btn btn-panel waves-effect waves-themed",
        attrs: {
          "data-action": "panel-fullscreen",
          "data-toggle": "tooltip",
          "data-offset": "0,10",
          "data-original-title": "Fullscreen",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }